import { useQuery } from '@apollo/client'
import PropTypes from 'prop-types'

import { Text, Link } from '@components'

import styles from './style.module.css'

import { getPopularArticles } from '@gql/blogQuery'

function PopularArticles({ limit }) {
  const { data: { articles = [] } = {} } = useQuery(getPopularArticles, {
    variables: {
      limit,
    },
  })

  return (
    <div className={styles.container}>
      {articles.map(({ title, titleSlug }, index) => {
        return (
          <div key={titleSlug} className={styles.text}>
            <Text
              tag="h3"
              variant="subtitle"
              color="darkPeach"
              className={styles.articleOrder}
            >
              {index + 1}
            </Text>
            <Text variant="lightDescription" className={styles.articleTitle}>
              <Link link={`/blog/${titleSlug}`}>{title}</Link>
            </Text>
          </div>
        )
      })}
    </div>
  )
}

PopularArticles.propTypes = {
  limit: PropTypes.number.isRequired,
}

export default PopularArticles
